import { store } from "./store";
import loginService from "./login";

export function login_local(context) {
  context.loading = !context.loading;
  context.message = null;

  loginService.API.Actions.login(context.usuario, context.senha, context._token)
    .then((resp) => {
      if (resp.status == 200) {
        store.dispatch("login", resp.data).then(() => {
          if (context.loginCallback) context.loginCallback(resp.data);

          context.$router.push({ name: context.loginRedirect });
          context.loading = false;
        });
      } else {
        context.message = resp.data.error ? resp.data.error : "Usuário ou senha incorretos!";
      }
    })
    .catch((err) => {
      context.loading = false;
      context.message = err.response.data.error ? err.response.data.error : "Usuário ou senha incorretos!";
      context.getCSFRToken = !context.getCSFRToken;
    });
}
